import { type SVGProps } from 'react';

export type TSvgAssetProps = Omit<SVGProps<SVGSVGElement>, 'aria-hidden'> &
  (
    | {
        title?: never;
        'aria-hidden'?: true | 'true';
      }
    | {
        title?: string;
        'aria-hidden'?: never;
      }
  );

function SvgAsset(props: TSvgAssetProps) {
  const { title, children, ...rest } = props;

  return (
    <svg {...rest} xmlns="http://www.w3.org/2000/svg">
      {title && <title>{title}</title>}
      {children}
    </svg>
  );
}

export { SvgAsset };
